module.exports = __webpack_public_path__ + "img/clipboard.4a2f2ac8.svg";